import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { AngularResizedEventModule } from 'angular-resize-event';
import { ClipboardModule } from 'ngx-clipboard';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { AssessmentWrapperComponent } from './custom-component/components/assessment-wrapper/assessment-wrapper.component';
import { CategoryCardComponent } from './custom-component/components/assessment-wrapper/category-card/category-card.component';
import { AssessmentControlComponent } from './custom-component/components/assessment-wrapper/control/assessment-control.component';
import { OptionalInputsComponent } from './custom-component/components/assessment-wrapper/optional-inputs/optional-inputs.component';
import { QuestionCardComponent } from './custom-component/components/assessment-wrapper/question-card/question-card.component';
import { QuestionContentComponent } from './custom-component/components/assessment-wrapper/question-content/question-content.component';
import { AssessmentStatusComponent } from './custom-component/components/assessment-wrapper/status/assessment-status.component';
import { TooltipDialog } from './custom-component/components/assessment-wrapper/tooltip-dialog/tooltip-dialog.component';
import { TotalStatisticComponent } from './custom-component/components/assessment-wrapper/total-statistic/total-statistic.component';
import { CalenderWrapperComponent } from './custom-component/components/calendar-wrapper/calendar-wrapper.component';
import { ScheduleDialogComponent } from './custom-component/components/calendar-wrapper/schedule-dialog/schedule-dialog.component';
import { ChartsWrapperComponent } from './custom-component/components/charts-wrapper/charts-wrapper.component';
import { ClassificationIndicatorsWrapperComponent } from './custom-component/components/classification-indicators-wrapper/classification-indicators-wrapper.component';
import { ClassificationCommentsComponent } from './custom-component/components/classification-indicators-wrapper/comments/classification-comments.component';
import { ClassificationIndicatorComponent } from './custom-component/components/classification-indicators-wrapper/indicator/classification-indicator.component';
import { ClassificationIndicatorQuestionComponent } from './custom-component/components/classification-indicators-wrapper/question/classification-indicator-question.component';
import { ClassificationStatusComponent } from './custom-component/components/classification-indicators-wrapper/status/classification-indicator-status.component';
import { CommentsHistoryWrapperComponent } from './custom-component/components/comments-history-wrapper/comments-history-wrapper.component';
import { AddEditEditgridContent } from './custom-component/components/editgrid-resource-wrapper/add-edit-editgrid-content/add-edit-editgrid-content.component';
import { EditgridResourceWrapperComponent } from './custom-component/components/editgrid-resource-wrapper/editgrid-resource-wrapper.component';
import { EventTreeWrapperComponent } from './custom-component/components/event-tree-wrapper/event-tree-wrapper.component';
import { FormByKeyComponent } from './custom-component/components/form-key-wrapper/form-by-key/form-by-key.component';
import { FormKeyWrapperComponent } from './custom-component/components/form-key-wrapper/form-key-wrapper.component';
import { GroupedTableWrapperComponent } from './custom-component/components/grouped-table-wrapper/grouped-table-wrapper.component';
import { HijriDateComponent } from './custom-component/components/hijri-date-wrapper/hijri-date.component';
import { IndicatorComponent } from './custom-component/components/indicators-wrapper/indicator/indicator.component';
import { IndicatorsWrapperComponent } from './custom-component/components/indicators-wrapper/indicators-wrapper.component';
import { IndicatorQuestionComponent } from './custom-component/components/indicators-wrapper/question/indicator-question.component';
import { StatusComponent } from './custom-component/components/indicators-wrapper/status/indicator-status.component';
import { MapWrapperComponent } from './custom-component/components/map-wrapper/map-wrapper.component';
import { AddEditResourceDialog } from './custom-component/components/master-details-resource-wrapper/add-edit-dialog/add-edit-dialog.component';
import { MasterDetailsResourceWrapperComponent } from './custom-component/components/master-details-resource-wrapper/master-details-resource-wrapper.component';
import { PDFWrapperComponent } from './custom-component/components/pdf-wrapper/pdf-wrapper.component';
import { ProccessRequirmentsWrapperComponent } from './custom-component/components/proccess-requirments-wrapper/proccess-requirments-wrapper.component';
import { RatingWrapperComponent } from './custom-component/components/rating-wrapper/rating-wrapper.component';
import { RedirectionButtonWrapperComponent } from './custom-component/components/redirection-button-wrapper/redirection-button-wrapper.component';
import { ResourceDropdownWrapperComponent } from './custom-component/components/resource-dropdown-wrapper/resource-dropdown-wrapper.component';
import { StepperWrapperComponent } from './custom-component/components/stepper-wrapper/stepper-wrapper.component';
import { AddEditDialog } from './custom-component/components/table-tree-wrapper/add-edit-dialog/add-edit-dialog.component';
import { TableTreeWrapperComponent } from './custom-component/components/table-tree-wrapper/table-tree-wrapper.component';
import { TableViewWrapperComponent } from './custom-component/components/table-view-wrapper/table-view-wrapper.component';
import { EditTemplateDialog } from './custom-component/components/template-wrapper/edit-template-dialog/edit-template-dialog.component';
import { DocumentEditorSidebarComponent } from './custom-component/components/template-wrapper/template-process/document-editor-sidebar/document-editor-sidebar.component';
import { TemplateProcessComponent } from './custom-component/components/template-wrapper/template-process/template-process.component';
import { TemplateWrapperComponent } from './custom-component/components/template-wrapper/template-wrapper.component';
import { BottomSheetOverviewComponent } from './custom-component/dialogs/bottom-sheet-overview/bottom-sheet-overview.component';
import { ConfirmationDialogComponent } from './custom-component/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ExtraFormDialog } from './custom-component/dialogs/extra-form-dialog/extra-form-dialog.component';

import { TooltipModule } from 'primeng/tooltip';
import { FormioModule, googleMapKey } from 'dp-formio';
import { CardWrapperComponent } from './custom-component/components/card-wrapper/card-wrapper.component';
import { UIChartComponent } from './custom-component/components/charts-wrapper/chart/chart.component';
import { CommentsHistoryDialogComponent } from './custom-component/components/comments-history-wrapper/comments-history-dialog/comments-history-dialog.component';
import { DistributeCommonQuestionsModule } from './custom-component/components/distribute-common-questions';
import { DistributeTeamMembersModule } from './custom-component/components/distribute-team-members/distribute-team-members.module';
import { DynamicChartWrapperComponent } from './custom-component/components/dynamic-chart-wrapper/dynamic-chart-wrapper.component';
import { AddEditEventItem } from './custom-component/components/event-tree-wrapper/add-edit-event-item/add-edit-event-item.component';
import { CopyDecisionComponent } from './custom-component/components/execute-visit-wrapper/copy-decision/copy-decision.component';
import { CriteriaDecisionComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-decision/criteria-decision/criteria-decision.component';
import { CriterionDecisionComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-decision/criterion-decision.component';
import { QuestionDecisionComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-decision/question-decision/question-decision.component';
import { CriteriaPreviewComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-preview/criteria-preview/criteria-preview.component';
import { OptionalInputsPreviewComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-preview/criteria-preview/optional-inputs-preview/optional-inputs-preview.component';
import { TotalStatisticPreviewComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-preview/criteria-preview/total-statistic-preview/total-statistic-preview.component';
import { CriterionPreviewComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-preview/criterion-preview.component';
import { QuestionPreviewComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterion-preview/question-preview/question-preview.component';
import { CriterionsTreeComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/criterions-tree.component';
import { AddEditResponseComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/decision-summary/add-edit-response/add-edit-response.dialog';
import { AddEditSummaryComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/decision-summary/add-edit-summary/add-edit-summary.dialog';
import { DecisionSummaryComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/decision-summary/decision-summary.component';
import { SummaryFilterComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/decision-summary/summary-filter/summary-filter.component';
import { AddEditExecutivePlanComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/executive-plan/add-edit-executive-plan/add-edit-executive-plan.dialog';
import { ExecutivePlanComponent } from './custom-component/components/execute-visit-wrapper/criterions-tree/executive-plan/executive-plan.component';
import { ExecuteVisitWrapperComponent } from './custom-component/components/execute-visit-wrapper/execute-visit-wrapper.component';
import { MasarCriteriaDecisionComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-decision/criteria-decision/masar-criteria-decision.component';
import { MasarCriterionDecisionComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-decision/masar-criterion-decision.component';
import { MasarQuestionDecisionComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-decision/question-decision/masar-question-decision.component';
import { MasarCriteriaPreviewComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-preview/criteria-preview/masar-criteria-preview.component';
import { MasarOptionalInputsPreviewComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-preview/criteria-preview/optional-inputs-preview/masar-optional-inputs-preview.component';
import { MasarTotalStatisticPreviewComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-preview/criteria-preview/total-statistic-preview/masar-total-statistic-preview.component';
import { MasarCriterionPreviewComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-preview/masar-criterion-preview.component';
import { MasarQuestionPreviewComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/criterion-preview/question-preview/masar-question-preview.component';
import { MasarAddEditResponseComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/decision-summary/add-edit-response/masar-add-edit-response.dialog';
import { MasarDecisionSummaryComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/decision-summary/masar-decision-summary.component';
import { MasarAddEditExecutivePlanComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/executive-plan/add-edit-executive-plan/masar-add-edit-executive-plan.dialog';
import { MasarExecutivePlanComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/executive-plan/masar-executive-plan.component';
import { MasarCriterionsTreeComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/masar-criterions-tree.component';
import { MembersSelectorComponent } from './custom-component/components/execute-visit-wrapper/members-selector/members-selector.component';
import { DisplayOrderPatternPipe } from './custom-component/components/execute-visit-wrapper/pipes/display-order-pattern.pipe';
import { EvaluationScoreMessagePipe } from './custom-component/components/execute-visit-wrapper/pipes/evaluation-score-message.pipe';
import { HtmlEditorWrapperComponent } from './custom-component/components/html-editor-wrapper/html-editor-wrapper.component';
import { AddEditOrgItem } from './custom-component/components/org-wrapper/add-edit-org-item/add-edit-org-item.component';
import { OrgReviewerFilterComponent } from './custom-component/components/org-wrapper/org-reviewer-filter/org-reviewer-filter.component';
import { OrgWrapperComponent } from './custom-component/components/org-wrapper/org-wrapper.component';
import { RejectReasonOrgItem } from './custom-component/components/org-wrapper/reject-reason-org-item/reject-reason-org-item.component';
import { EvaluationDisplayPipe } from './custom-component/components/resource-autocomplete-wrapper/pipe/evaluation-display.pipe';
import { ResourceAutocompleteWrapperComponent } from './custom-component/components/resource-autocomplete-wrapper/resource-autocomplete-wrapper.component';
import { VisitScheduleComponent } from './custom-component/components/visit-schedule/visit-schedule.component';
import { FormioDialogComponent } from './custom-component/dialogs/index';
import { CustomDynamicComponentsModule } from './custom-dynamic-components.module';
import { MaterialModule } from './material.module';
import { FormIoSkeletonModule } from './shared/components';
import { CountUpDirective } from './shared/directives/count-up.directive';
import { DisplayExternalActionsDirective } from './shared/directives/display-external-actions.directive';
import { SafeHtmlPipe } from './shared/directives/safeHtml.directive';
import { SplitAreaDirective } from './shared/directives/split-area.directive';
import { SplitHandleDirective } from './shared/directives/split-handle.directive';
import { SplitDirective } from './shared/directives/split.directive';

import { CustomSelectModule } from 'src/formio-custom-components/src/lib/custom-component/components/custom-select';
import { AllowedSummaryTypeDirective } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/directive/allowed-summary-type.directive';
import { AddEditMistakeComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/mistake-list/add-edit-mistake/add-edit-mistake.dialog';
import { MasarMistakeListComponent } from './custom-component/components/execute-visit-wrapper/masar-criterions-tree/mistake-list/masar-mistake-list.component';
import { NumberCounterWrapperComponent } from './custom-component/components/number-counter-wrapper/number-counter-wrapper.component';
import { ViewFormDialog } from './custom-component/components/org-wrapper/view-form/view-form.component';
import { CssClassDisplayPipe } from './custom-component/components/resource-autocomplete-wrapper/pipe/css-class-display.pipe';
import { CalculatedRatioPipe } from './shared/pipes/calculated-ratio';
import { CalculatedRowRatioPipe } from './shared/pipes/calculated-row-ratio';
import { CalculatedRowTotalPipe } from './shared/pipes/calculated-row-total';
import { CalculatedTotalPipe } from './shared/pipes/calculated-total';
import { DisplayTimePipe } from './shared/pipes/display-time';
import { SafeUrlPipe } from './shared/pipes/safeURL.pipes';
import { DateToTimeAgoPipe } from './shared/pipes/time-ago.pipe';
import { ReviewingEvaluationWrapperComponent } from './custom-component/components/reviewing-evaluation-wrapper/reviewing-evaluation-wrapper.component';
import { SortPipe } from './shared/pipes/sort.pipe';
import { CriterionEvaluationComponent } from './custom-component/components/reviewing-evaluation-wrapper/criterion-evaluation/criterion-evaluation.component';
import { GeneralReportComponent } from './custom-component/components/reviewing-evaluation-wrapper/general-report/general-report.component';

export const agmCoreModule = AgmCoreModule.forRoot({
  apiKey: googleMapKey,
  libraries: ['places'],
});
@NgModule({
	declarations: [
		SplitHandleDirective,
		SplitAreaDirective,
		SplitDirective,
		CountUpDirective,
		DisplayExternalActionsDirective,
		AllowedSummaryTypeDirective,

		SafeHtmlPipe,
		SafeUrlPipe,
		CalculatedTotalPipe,
		CalculatedRowTotalPipe,
		CalculatedRatioPipe,
		CalculatedRowRatioPipe,
		DateToTimeAgoPipe,
		DisplayTimePipe,
		EvaluationScoreMessagePipe,
		EvaluationDisplayPipe,
		CssClassDisplayPipe,
		DisplayOrderPatternPipe,
		SortPipe,

		TableTreeWrapperComponent,
		MasterDetailsResourceWrapperComponent,
		AddEditDialog,
		AddEditResourceDialog,
		AssessmentWrapperComponent,
		AssessmentControlComponent,
		CategoryCardComponent,
		QuestionCardComponent,
		QuestionContentComponent,
		AssessmentStatusComponent,
		OptionalInputsComponent,
		TotalStatisticComponent,
		TooltipDialog,
		TemplateWrapperComponent,
		EditTemplateDialog,
		TemplateProcessComponent,
		DocumentEditorSidebarComponent,
		ProccessRequirmentsWrapperComponent,
		ReviewingEvaluationWrapperComponent,
		CriterionEvaluationComponent,
		GeneralReportComponent,
		FormKeyWrapperComponent,
		EditgridResourceWrapperComponent,
		AddEditEditgridContent,
		GroupedTableWrapperComponent,
		FormByKeyComponent,
		HijriDateComponent,
		ClassificationIndicatorsWrapperComponent,
		ClassificationStatusComponent,
		ClassificationIndicatorQuestionComponent,
		ClassificationIndicatorComponent,
		ClassificationCommentsComponent,
		IndicatorsWrapperComponent,
		IndicatorComponent,
		IndicatorQuestionComponent,
		StatusComponent,
		MapWrapperComponent,
		ExtraFormDialog,
		StepperWrapperComponent,
		RedirectionButtonWrapperComponent,
		TableViewWrapperComponent,
		PDFWrapperComponent,
		RatingWrapperComponent,
		CommentsHistoryWrapperComponent,
		CommentsHistoryDialogComponent,
		ChartsWrapperComponent,
		ConfirmationDialogComponent,
		BottomSheetOverviewComponent,
		ResourceDropdownWrapperComponent,
		ResourceAutocompleteWrapperComponent,
		EventTreeWrapperComponent,
		OrgWrapperComponent,
		CalenderWrapperComponent,
		ScheduleDialogComponent,
		AddEditEventItem,
		AddEditOrgItem,
		ViewFormDialog,
		OrgReviewerFilterComponent,
		RejectReasonOrgItem,
		HtmlEditorWrapperComponent,
		NumberCounterWrapperComponent,
		ExecuteVisitWrapperComponent,
		CriterionsTreeComponent,
		MasarCriterionsTreeComponent,
		CriterionDecisionComponent,
		MasarCriterionDecisionComponent,
		CriterionPreviewComponent,
		MasarCriterionPreviewComponent,
		QuestionPreviewComponent,
		MasarQuestionPreviewComponent,
		CriteriaPreviewComponent,
		MasarCriteriaPreviewComponent,
		QuestionDecisionComponent,
		MasarQuestionDecisionComponent,
		CriteriaDecisionComponent,
		MasarCriteriaDecisionComponent,
		TotalStatisticPreviewComponent,
		MasarTotalStatisticPreviewComponent,
		OptionalInputsPreviewComponent,
		MasarOptionalInputsPreviewComponent,
		MembersSelectorComponent,
		CopyDecisionComponent,
		DecisionSummaryComponent,
		MasarDecisionSummaryComponent,
		AddEditSummaryComponent,
		SummaryFilterComponent,
		ExecutivePlanComponent,
		MasarExecutivePlanComponent,
		MasarMistakeListComponent,
		AddEditExecutivePlanComponent,
		MasarAddEditExecutivePlanComponent,
		AddEditMistakeComponent,
		AddEditResponseComponent,
		MasarAddEditResponseComponent,
		EvaluationScoreMessagePipe,
		DisplayOrderPatternPipe,
		VisitScheduleComponent,
		CardWrapperComponent,
		DynamicChartWrapperComponent,
		FormioDialogComponent,
		UIChartComponent,
	],

	imports: [
		CommonModule,
		FormioModule,
		MaterialModule,
		ReactiveFormsModule,
		FlexLayoutModule,
		TranslateModule,
		FormsModule,
		ButtonModule,
		NgbModule,
		NgSelectModule,
		TableModule,
		EditorModule,
		ClipboardModule,
		agmCoreModule,
		ChartModule,
		DialogModule,
		CarouselModule,
		TooltipModule,
		ProgressBarModule,
		AngularResizedEventModule,
		CardModule,
		InfiniteScrollModule,
		FullCalendarModule,
		OrganizationChartModule,
		DistributeTeamMembersModule,
		CustomDynamicComponentsModule,
		DistributeCommonQuestionsModule,
		FormIoSkeletonModule,
		CustomSelectModule,
	],
	providers: [],
	entryComponents: [
		TableTreeWrapperComponent,
		MasterDetailsResourceWrapperComponent,
		AddEditResourceDialog,
		AssessmentWrapperComponent,
		AssessmentControlComponent,
		OptionalInputsComponent,
		TotalStatisticComponent,
		TooltipDialog,
		EditTemplateDialog,
		TemplateWrapperComponent,
		TemplateProcessComponent,
		ProccessRequirmentsWrapperComponent,
		ReviewingEvaluationWrapperComponent,
		CriterionEvaluationComponent,
		GeneralReportComponent,
		FormKeyWrapperComponent,
		EditgridResourceWrapperComponent,
		GroupedTableWrapperComponent,
		HijriDateComponent,
		ClassificationIndicatorsWrapperComponent,
		ClassificationIndicatorComponent,
		IndicatorsWrapperComponent,
		MapWrapperComponent,
		ExtraFormDialog,
		IndicatorComponent,
		AddEditEditgridContent,
		AddEditDialog,
		StepperWrapperComponent,
		RedirectionButtonWrapperComponent,
		TableViewWrapperComponent,
		PDFWrapperComponent,
		RatingWrapperComponent,
		CommentsHistoryWrapperComponent,
		CommentsHistoryDialogComponent,
		ChartsWrapperComponent,
		ConfirmationDialogComponent,
		BottomSheetOverviewComponent,
		ResourceDropdownWrapperComponent,
		ResourceAutocompleteWrapperComponent,
		EventTreeWrapperComponent,
		OrgWrapperComponent,
		CalenderWrapperComponent,
		ScheduleDialogComponent,
		AddEditEventItem,
		AddEditOrgItem,
		ViewFormDialog,
		RejectReasonOrgItem,
		HtmlEditorWrapperComponent,
		NumberCounterWrapperComponent,
		ExecuteVisitWrapperComponent,
		VisitScheduleComponent,
		CardWrapperComponent,
		DynamicChartWrapperComponent,
		AddEditSummaryComponent,
		AddEditExecutivePlanComponent,
		MasarAddEditExecutivePlanComponent,
		AddEditMistakeComponent,
		AddEditResponseComponent,
		MasarAddEditResponseComponent,
		FormioDialogComponent,
		UIChartComponent,
	],
	exports: [
		// FormioModule,
		AddEditDialog,
		AddEditResourceDialog,
		TooltipDialog,
		ConfirmationDialogComponent,
		BottomSheetOverviewComponent,
		ResourceDropdownWrapperComponent,
		ResourceAutocompleteWrapperComponent,
		EventTreeWrapperComponent,
		OrgWrapperComponent,
		CalenderWrapperComponent,
		NgbModule,
		ButtonModule,
		CardModule,
		NgSelectModule,
		ExecuteVisitWrapperComponent,
		VisitScheduleComponent,
		CardWrapperComponent,
		DynamicChartWrapperComponent,
		AddEditSummaryComponent,
		AddEditExecutivePlanComponent,
		MasarAddEditExecutivePlanComponent,
		AddEditMistakeComponent,
		AddEditResponseComponent,
		MasarAddEditResponseComponent,
		EvaluationDisplayPipe,
		CssClassDisplayPipe,
		SortPipe,
		CustomDynamicComponentsModule,
		DistributeCommonQuestionsModule,
	],
})
export class FormioCustomComponentModule {
	// static forRoot(): ModuleWithProviders<any> {
	// 	return {
	// 		ngModule: FormioCustomComponentModule,
	// 		providers: [CustomTagsService]
	// 	};
	// }
}
